import { getGoviewProjectList, GoviewProject } from '@/api/goview';
import { useTableRequest } from '@/hooks';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Card, Col, Empty, Form, Input, Pagination, Row, Space, Spin, Typography } from 'antd';
import React, { useRef } from 'react';
import { CreateProjectModal, CreateProjectModalRef } from './CreateProjectModal';
import './index.less';
import ProjectCard from './ProjectCard';

const { Title, Paragraph } = Typography;

type DataScreenProps = {};

const DataScreen: React.FC<DataScreenProps> = () => {
  const createProjectModalRef = useRef<CreateProjectModalRef>(null);
  const { loading, form, dataSource, pagination, reload, search, reset } = useTableRequest<GoviewProject>({
    onRequest: (data) => {
      const { projectName, ...rest } = data;
      return getGoviewProjectList({
        ...rest,
        name: projectName || undefined,
      } as any);
    },
    defaultPagination: { current: 1, pageSize: 12 },
  });

  return (
    <>
      <Card className="m20" size="small">
        <Form
          layout="inline"
          form={form}
          initialValues={{
            projectName: '',
          }}
        >
          <Form.Item key="projectName" name="projectName">
            <Input placeholder="项目名称" style={{ width: 180 }} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={search}>
              查询
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="default" onClick={reset}>
              重置
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <Card className="m20" size="small">
        <Space className="mb15 justify-space-between" style={{ width: '100%' }}>
          <div>
            <Button
              type="primary"
              onClick={() => {
                createProjectModalRef.current?.open();
              }}
            >
              <PlusOutlined />
              创建项目
            </Button>
          </div>
          <div className="flex-center">
            <Button
              onClick={() => {
                reload();
              }}
            >
              <ReloadOutlined />
              刷新
            </Button>
          </div>
        </Space>
        <Spin spinning={loading}>
          {!loading && (!dataSource || dataSource.length === 0) ? (
            <Empty description="暂无数据" style={{ padding: '60px 0' }} />
          ) : (
            <>
              <Row gutter={[16, 16]}>
                {dataSource?.map((record: GoviewProject) => (
                  <Col key={record.id} xs={24} sm={12} md={8} lg={6} xl={6} xxl={6}>
                    <ProjectCard record={record} onDelete={reload} />
                  </Col>
                ))}
              </Row>
              {pagination && (
                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
                  <Pagination
                    {...pagination}
                    showTotal={(total) => `共 ${total} 条`}
                  />
                </div>
              )}
            </>
          )}
        </Spin>
      </Card>
      <CreateProjectModal ref={createProjectModalRef} onFinish={reload} />
    </>
  );
};

export default DataScreen;

